
/*
  Colour palette
  https://www.figma.com/file/CNdRNb3JOu1KfCghQJmDne/Ixico-design-system?node-id=12%3A2
*/

const standardColours = {
  yellow: "#FFC941",
  darkOrange: "#EB8A00",
  lightRed: "#EF878D",
  lightPurple: "#A26CBB",
  darkPurple: "#713ADD",
  lightBlue: "#4B7CF2",
  teal: "#29B5C3",
  lightGreen: "#81D2BC",
  green: "#00B886",
  blue: "#0040DA",
};

const notificationColours = {
  red: "#F24B4B",
  orange: "#FEB751",
  green: "#DCF0D7"
};

const greys = {
  100: "#FFFFFF",
  200: "#F3F3F3",
  300: "#EDEDED",
  400: "#EAE9E9",
  500: "#C0BEBE",
  600: "#9F9D9D",
  700: "#808184",
  800: "#777777",
  900: "#04042B",
  1000: "#ADADAD",
  1100: "#C4C4C4"
};

const ixicoGreens = {
  100: "#F1F8F9",
  200: "#E1F2F4",
  300: "#96CED7",
  400: "#2CB4C3",
  500: "#41B6C2",
  600: "#2E9FAE",
  700: "#1A8493"
};

const purple = {
  100: "#F2F3FA",
  200: "#E4E7F5",
  300: "#9EA6D4",
  400: "#4D5CB0",
  500: "#5B6ABF",
  600: "#4A5699"
};

const templateColours = {
  100: "#FBFBFB",
  200: "#F9F9F9",
  300: "#F3F4F5"
};

const nav = {
  background: "#04042B",
  activeItem: "#1B1F4F",
  tooltip: "#1B1F4F",
  activeTab: "#75EBEC",
  text: "#FFFFFF",
  focusRing: "#5B6ABF",
  avatar: "#00A1AF",
  footerText: "rgba(4,4,43,0.6)",
};

const colors = {
  mainLayout: templateColours,
  highlight: ixicoGreens,
  purple,
  body: greys,
  nav,
  tiles: {
    100: standardColours.yellow,
    200: standardColours.darkOrange,
    300: standardColours.lightRed,
    400: standardColours.lightPurple,
    500: standardColours.darkPurple,
    600: standardColours.lightBlue,
    700: ixicoGreens[400],
    800: standardColours.lightGreen,
    900: standardColours.darkPurple,
    1000: notificationColours.orange
  },
  notifications: {
    100: notificationColours.red,
    200: notificationColours.orange,
    300: notificationColours.green,
    400: ixicoGreens[400],
    500: greys[300]
  },
  labelBackground: {
    100: standardColours.blue,
    200: standardColours.lightGreen,
    300: standardColours.lightPurple,
    400: standardColours.darkOrange,
    500: ixicoGreens[400],
    600: standardColours.darkPurple,
    700: standardColours.lightRed,
    800: standardColours.green
  },
  labelBackgroundLight: {
    100: "#D9E2FA", // light blue (from blue #0040DA)
    200: "#E6F6F1", // light green (from lightGreen #81D2BC)
    300: "#EDE1F2", // light purple (from lightPurple #A26CBB)
    400: "#FCE8CC", // light orange (from darkOrange #EB8A00)
    500: "#D5F0F3", // light ixicoGreen (from #2CB4C3)
    600: "#E3D8FA", // light dark purple (from darkPurple #713ADD)
    700: "#FCE1E3", // light red (from lightRed #EF878D)
    800: "#CCF1E7", // light green (from green #00B886)
    900: "#FCDADA" // light darkRed (from error.100 #F24B4B)
  },
  labelBackgroundMedium: {
    100: "#6D91ED", // mid blue (between light #D9E2FA and full #0040DA)
    200: "#B3E4D6", // mid lightGreen (between light #E6F6F1 and full #81D2BC)
    300: "#C7A6CF", // mid lightPurple (between light #EDE1F2 and full #A26CBB)
    400: "#F3B966", // mid orange (between light #FCE8CC and full #EB8A00)
    500: "#80D2DB", // mid ixicoGreen (between light #D5F0F3 and full #2CB4C3)
    600: "#AA89E5", // mid darkPurple (between light #E3D8FA and full #713ADD)
    700: "#F3B4B8", // mid red (between light #FCE1E3 and full #EF878D)
    800: "#66D5B6", // mid green (between light #CCF1E7 and full #00B886)
    900: "#F99A9A" // mid darkRed (between light #FCDADA and full #F24B4B)
  },
  error: {
    100: notificationColours.red,
    200: standardColours.lightRed,
  },
  toast: {
    success: notificationColours.green,
    info: ixicoGreens[400],
    warning: notificationColours.orange,
    error: notificationColours.red,
  },
  standardColours: standardColours
};

export { colors };
